import { RESULTS_PER_PAGE, TagResultsResponse } from "./types";
import { gql } from 'graphql-request'
import { request } from 'graphql-request'
import {sitecoreApiKey, sitecoreApiHost, graphQLEndpointPath} from '../../temp/config'

export const SEARCH_QUERY = gql`
query Tags($first: Int!, $tag: String!, $after: String!) {
  tags(first: $first, tag: $tag, after: $after) {
    tagFriendlyName
    relatedTags {
      friendlyName
      tagName
    }
    results {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      items {
        description
        thumbnail
        url
        title
      }
    }
  }
}
`

export async function fetchGraphQL(tag: string, after: string): Promise<TagResultsResponse | null> {
  try {
    const isServer = typeof window === 'undefined';
    const host = isServer ? 'http://localhost' : sitecoreApiHost;

    const url = host + graphQLEndpointPath + "?sc_apiKey=" + sitecoreApiKey;
    const response: TagResultsResponse = await request({
      url: url,
      document: SEARCH_QUERY,
      variables: {
        first: RESULTS_PER_PAGE,
        tag: tag,
        after: after,
      },
    });
    return response;
    
  } catch (error) {
    console.error('[TagResults] - GraphQL call failed:', error);
    return null;
  }
}
  
  